export default function getCustomerDetails({ newUserDetails = {}, firstName, phoneWithMask }) {
  const name = [newUserDetails.billing_first_name || firstName, newUserDetails.billing_last_name]
    .filter(Boolean)
    .join(' ');
  const address = [
    newUserDetails.billing_address,
    newUserDetails.billing_city,
    newUserDetails.billing_state,
    newUserDetails.billing_zip,
  ]
    .filter(Boolean)
    .join(', ');

  return {
    name,
    phone: phoneWithMask ? `+1 ${phoneWithMask}` : undefined,
    email: newUserDetails.email || undefined,
    address: address || undefined,
  };
}
